"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSSR = isSSR;
exports.getServerInstance = getServerInstance;
const proxy_1 = require("../proxy");
const logger_1 = require("./logger");
const watch_1 = require("./watch");
function isSSR() {
    return typeof document === 'undefined' || typeof window === 'undefined';
}
const FakeStorage = {
    loadList: () => [],
    saveList: () => null,
};
let instance = false;
function createInstance() {
    const logger = new logger_1.SSRLogger();
    const watcher = new watch_1.SSRChannelWatch(FakeStorage);
    const { watch, unwatch, watching } = watcher;
    const proxy = new proxy_1.Proxy(logger, watching);
    const { error, warn, info, log, trace, createLogger, list, alert, alertOnError } = proxy;
    return {
        watch,
        unwatch,
        watching,
        error,
        warn,
        info,
        log,
        trace,
        createLogger,
        list,
        getServerSideLogs: logger.getServerSideLogs,
        alert,
        alertOnError,
    };
}
function getServerInstance() {
    if (!instance) {
        instance = createInstance();
    }
    return instance;
}
//# sourceMappingURL=index.js.map